(() => {
  const root = document.getElementById('ph-market-choice');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = document.getElementById('PHMarketChoiceForm');
  const select = document.getElementById('PHMarketCountry');
  const panel = root.querySelector('.ph-market-choice__recommendation');
  const key = 'ph_market_choice_v1';
  const remember = () => { try { sessionStorage.setItem(key, 'chosen'); } catch (_) {} };
  form.addEventListener('submit', remember);
  root.querySelector('[data-ph-market-dismiss]').addEventListener('click', () => { panel.hidden = true; remember(); });
  try { if (sessionStorage.getItem(key)) return; } catch (_) {}
  if (window.Shopify?.designMode) return;
  const base = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams({'country[enabled]':'true','country[exclude]':root.dataset.currentCountry,'language[enabled]':'false'});
  fetch(base + 'browsing_context_suggestions.json?' + params, {credentials:'same-origin'})
    .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
    .then(data => {
      const suggestion = data.suggestions?.find(item => item.parts?.country)?.parts.country;
      if (!suggestion || suggestion.handle === root.dataset.currentCountry) return;
      const option = Array.from(select.options).find(item => item.value === suggestion.handle);
      if (!option) return;
      root.querySelector('[data-ph-market-message]').textContent = root.dataset.suggestionTemplate.replace('[country]', suggestion.name || option.textContent);
      root.querySelector('[data-ph-market-accept]').addEventListener('click', () => { select.value = suggestion.handle; form.requestSubmit(); }, {once:true});
      panel.hidden = false;
    })
    .catch(() => {});
})();
